var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('Header',{attrs:{"title":"RA2S - Serviços de Telecomunicação Ltda.","hideToggle":!_vm.user,"hideUserDropdown":!_vm.user}}),_c('v-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }